var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHamburger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "14px",
    viewBox: "0 0 24 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u2705-Feather-(Neutral)",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Cockpit-User-Navigation-open",
    transform: "translate(-28.000000, -33.000000)",
    fill: "#145685"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gemeindenk\\xFCrzel"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Menu-Toggle",
    transform: "translate(28.000000, 33.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 24,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy",
    x: 0,
    y: 6,
    width: 24,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-3",
    x: 0,
    y: 12,
    width: 24,
    height: 2
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburger);
export default __webpack_public_path__ + "static/media/hamburger.603d6607d199ad6af0e1b7e04bd9d872.svg";
export { ForwardRef as ReactComponent };